<template>
    <div class="bg-base-200 h-screen-header rounded-xl relative">
        <div class="h-full">
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Queue'
}
</script>
